import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages: string[] = ['en', 'es', 'de', 'it', 'ru'];

  constructor(public translate: TranslateService, private cookieService: CookieService) {
    let browserLang;
    this.translate.addLangs(this.languages);

    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    } else {
      this.setLanguage('en');
      browserLang = translate.getBrowserLang();
    }

    // Securely use the browser language, falling back to 'en' if necessary
    translate.use(browserLang.match(/en|es|de|it|ru/) ? browserLang : 'en');
  }

  public setLanguage(lang: string) {
    console.log('Setting language:', lang); // Debugging

    this.translate.use(lang);

    // Set the language cookie with secure options
    const expirationDays = 7; // Cookie expiration in days
    const isSecure = true; // Ensure HTTPS
    const sameSiteOption = 'Strict'; // Prevent CSRF

    // Set the cookie with enhanced security
    this.cookieService.set('lang', lang, expirationDays, '/', '', isSecure, sameSiteOption);
  }
}



// import { Injectable } from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
// import { CookieService } from 'ngx-cookie-service';

// @Injectable({ providedIn: 'root' })
// export class LanguageService {
//   public languages: string[] = ['en', 'es', 'de', 'it', 'ru'];

//   constructor(public translate: TranslateService, private cookieService: CookieService) {
//     let browserLang;
//     this.translate.addLangs(this.languages);
//     if (this.cookieService.check('lang')) {
//       browserLang = this.cookieService.get('lang');
//     }
//     else {
//       this.setLanguage('en');
//       browserLang = translate.getBrowserLang();
//     }
//     translate.use(browserLang.match(/en|es|de|it|ru/) ? browserLang : 'en');
//   }

//   public setLanguage(lang: string) {
//     console.log('Setting language:', lang); // Add this line for debugging
  
//     this.translate.use(lang);
    
//     // Set the language cookie with HttpOnly, Secure, and SameSite options
//     const expirationDays = 7; // Set your desired expiration time
//     const isSecure = true;
//     const sameSiteOption = 'Strict'; // Adjust this as needed
  
//     this.cookieService.set('lang', lang, expirationDays, '/', '', isSecure, sameSiteOption);
//   }

// }
